import React from 'react';
import {Spin} from "antd";
import CountUp from "react-countup";
import {LoadingOutlined, ProductOutlined, ShopOutlined, TeamOutlined, UserAddOutlined} from "@ant-design/icons";
import {Content, Item, ItemContent, Root, Title, TitleWrapper} from "./styled";
import {useDashboardContext} from "contexts/DashboardProvider";

const Counts = () => {
  const { state } = useDashboardContext()
  return (
    <Root>
      <TitleWrapper>
        <Title>Summary</Title>
      </TitleWrapper>
      <Content>
        <ItemCard
          className={"products"}
          count={state.counts.products}
          title={"PRODUCTS"}
          icon={<ProductOutlined />}
        />
        <ItemCard
          className={"suppliers"}
          count={state.counts.suppliers}
          title={"SUPPLIERS"}
          icon={<ShopOutlined />}
        />
        <ItemCard
          className={"customers"}
          count={state.counts.customers}
          title={"CUSTOMERS"}
          icon={<TeamOutlined />}
        />
        <ItemCard
          className={"users"}
          count={state.counts.users}
          title={"USERS"}
          icon={<UserAddOutlined />}
        />
      </Content>
    </Root>
  )
};

const ItemCard = ({
  className,
  count,
  title,
  icon
}) => {
  const { state } = useDashboardContext()
  return (
    <Item className={className}>
      <ItemContent>
        {icon}
        <div className={"count"}>
          {state.is_loading_counts
            ? <Spin indicator={<LoadingOutlined spin />} />
            : <CountUp
              end={count}
              duration={2}
            />
          }
        </div>
        <div>{title}</div>
      </ItemContent>
    </Item>
  )

}


export default Counts;
